module.exports = __webpack_public_path__ + "static/services-img4-627a1c391a5d64b25a4f1c17a4dcd7f7.png";